import axios from 'axios'
// 使用环境变量来管理API地址
import seetings from '../seetings/index'

//获取栏目信息
export const homeconfig = (string) => {
    return axios({
        url: `${seetings.baseUrl}/pages/${string}`,
        method: 'GET',
    })
}

//获取资讯列表
export const articles = (data) => {
    return axios({
        url: `${seetings.baseUrl}/client/articles`,
        method: 'GET',
        params:data
    })
}

//获取总配置
export const baseConfig = () => {
    return axios({
        url: `${seetings.baseUrl}/system_configs/site_config`,
        method: 'GET',
    })
}

//获取banner图
export const bannerConfig = (string) => {
    return axios({
        url: `${seetings.baseUrl}/pages/${string}/banners`,
        method: 'GET',
    })
}


// WEBPACK FOOTER //
// ./src/api/api.js